export default "__VITE_ASSET__D3PBsgf7__"